import { render } from "./VoucherLedgerList.vue?vue&type=template&id=d3baeaa4"
import script from "./VoucherLedgerList.vue?vue&type=script&lang=js"
export * from "./VoucherLedgerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__